<template>
  <b-form class="pt-1" @submit="onSubmitForm">

    <b-card title="สถานะค้นหา" border-variant="primary">
      <!-- Filter -->
      <b-col cols="12" md="12">
        <InputFilter :filter="search[0]" />
      </b-col>
      <!-- ปุ่มค้นหา / ยกเลิก -->
      <div class="text-center pt-1">
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          type="submit"
        >
          ค้นหา
        </b-button>
        <b-button 
          variant="outline-secondary" 
          type="reset" 
          @click="onResetBtnClicked"
        >
          ล้าง
        </b-button>
      </div>
    </b-card>

  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,

  BTab,
  BTabs,
  BOverlay,
  BCard,
} from "bootstrap-vue";
import index from "vue-prism-component";
import vSelect from "vue-select";
import InputFilter from "@/views/filters/components/InputFilter.vue";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,

    BTab,
    BTabs,
    BOverlay,
    BCard,
  },
  props: {
    // autoSearch: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  setup(props) {
    let statusObjs =[{ text: "สถานะ", value: "" }];

    // All,ToDo,InProgress,Done,Canceled
    const options = [
      { text: "All", value: 0 },
      { text: "ToDo", value: 1 },
      { text: "InProgress", value: 2 },
      { text: "Done", value: 3 },
      { text: "Canceled", value: 5 },
    ];

    const searchList = [
      {
        id: "status",
        label: "สถานะ",
        value: "",
        class: "",
        style: "",
        placeholder: "กรุณาเลือกสถานะสำหรับค้นหา",
        type: "bselect",
        options,
      }
    ];
    return {
      options,    
      statusObjs,
      statusObj:{
        text: "สถานะ",
        value: statusObjs.value,
      },
      search: searchList,
      props,
    };
  },
  mounted() {
    // if (this.props.autoSearch == true) {
    //   this.onSearchBtnClicked();
    // }
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked(){
      // this.search.forEach(item => {
      //   item.value.forup = null;
      // });
    },
    onSearchBtnClicked() {

      // set defualt สำหรับ search auto 
      const params = {
        status: 0,
      };

      if (this.search[0].value !== '' && 
          this.search[0].value !== null && 
          this.search[0].value !== undefined) {
        params.status = this.search[0].value;
      }

      console.log("Search - TabStatus", params);
      this.$emit("handleSubmitTabStatus", params);
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
